module.exports = __webpack_public_path__ + "static/media/logo-icerti@2x.64208ad5.png";